import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\UpdateItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/UpdateItemCategoryController.php
* @route '/api/item-category/{itemCategory}'
*/
const UpdateItemCategoryController = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemCategoryController.url(args, options),
    method: 'put',
})

UpdateItemCategoryController.definition = {
    methods: ["put"],
    url: '/api/item-category/{itemCategory}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ItemCategory\UpdateItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/UpdateItemCategoryController.php
* @route '/api/item-category/{itemCategory}'
*/
UpdateItemCategoryController.url = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { itemCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { itemCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            itemCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        itemCategory: typeof args.itemCategory === 'object'
        ? args.itemCategory.id
        : args.itemCategory,
    }

    return UpdateItemCategoryController.definition.url
            .replace('{itemCategory}', parsedArgs.itemCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\UpdateItemCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/UpdateItemCategoryController.php
* @route '/api/item-category/{itemCategory}'
*/
UpdateItemCategoryController.put = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemCategoryController.url(args, options),
    method: 'put',
})

export default UpdateItemCategoryController